import { render, staticRenderFns } from "./StockInvoiceTotalsPanel.vue?vue&type=template&id=63d782b8&scoped=true"
import script from "./StockInvoiceTotalsPanel.vue?vue&type=script&lang=js"
export * from "./StockInvoiceTotalsPanel.vue?vue&type=script&lang=js"
import style0 from "./StockInvoiceTotalsPanel.vue?vue&type=style&index=0&id=63d782b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d782b8",
  null
  
)

export default component.exports